import { render, staticRenderFns } from "./DepartMenu.vue?vue&type=template&id=6a5e9438&scoped=true&"
import script from "./DepartMenu.vue?vue&type=script&lang=js&"
export * from "./DepartMenu.vue?vue&type=script&lang=js&"
import style0 from "./DepartMenu.vue?vue&type=style&index=0&id=6a5e9438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e9438",
  null
  
)

export default component.exports